module.exports = __webpack_public_path__ + "static/inspiring_leader-9fb8662462b1c1cc64437a86189d9d96.jpg";